import random from 'lodash/random';

import { ColorConfig } from './types';

export const COLORS: Array<ColorConfig> = [
    ['#fadd4b', '#000'],
    ['#f8cd46', '#000'],
    ['#f3ad3e', '#000'],
    ['#ee702e', '#fff'],
    ['#eb4940', '#fff'],
    ['#b948f6', '#fff'],
    ['#6e41f5', '#fff'],
    ['#543ef5', '#fff'],
    ['#3b3df5', '#fff'],
    ['#9ce5fc', '#000'],
    ['#68c99e', '#000'],
    ['#5cb053', '#000'],
    ['#9dc943', '#000'],
    ['#90cc16', '#000'],
];

export const DEFAULT_COLOR = COLORS[random(0, COLORS.length - 1)];
